import { useEffect, useState } from 'react';
import type { SearchResult } from '../lib/search';

/** Debounced async search with stale-response protection for worker queries. */
export function usePhraseSearch(
  query: string,
  search: (query: string) => Promise<SearchResult[]>,
  delay = 40
) {
  const [results, setResults] = useState<SearchResult[]>([]);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    let active = true;
    const trimmed = query.trim();
    if (!trimmed) {
      setResults([]);
      setSearching(false);
      return () => { active = false; };
    }

    setSearching(true);
    const timer = window.setTimeout(() => {
      search(trimmed)
        .then((next) => { if (active) setResults(next); })
        .catch(() => { if (active) setResults([]); })
        .finally(() => { if (active) setSearching(false); });
    }, delay);

    return () => {
      active = false;
      window.clearTimeout(timer);
    };
  }, [query, search, delay]);

  return { results, searching };
}
